import { prepareUrlWithParams } from "./service.helpers.js";
export const getTabsProducts = async (endpoint = '', params = [], baseUrl = '')=>{
    if (!endpoint || !baseUrl) throw new Error('URL needed');
    if (params.length < 1) throw new Error('Params needed');
    if (process.env.NODE_ENV !== 'production') return Promise.resolve(await import("./mock.js").then((m)=>m.fetchGetTabsProductsMock));
    const url = prepareUrlWithParams(baseUrl, endpoint, params);
    const response = await fetch(url, {
        credentials: 'include'
    });
    if (!response.ok || response.status !== 200 && response.status !== 204) throw new Error(response.statusText);
    return response.json();
};

//# sourceMappingURL=service.js.map